export const ROLE_ADMIN = 'ADMIN';
